import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "./style/theme/index_adapter.scss";
import ElSelectV2 from "el-select-v2";

Vue.use(ElSelectV2);
Vue.use(ElementUI, {
  locale,
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
